export default __webpack_public_path__ + "d141c54b75a2b7a0f1ab83234804e907.svg";